__turbopack_context__.v({
  "contentInner": "HistoryEventView-module-scss-module__6YmyPW__contentInner",
  "contentWithImage": "HistoryEventView-module-scss-module__6YmyPW__contentWithImage",
  "contentWithoutImage": "HistoryEventView-module-scss-module__6YmyPW__contentWithoutImage",
  "dateLabel": "HistoryEventView-module-scss-module__6YmyPW__dateLabel",
  "descriptionMotion": "HistoryEventView-module-scss-module__6YmyPW__descriptionMotion",
  "descriptionScrollable": "HistoryEventView-module-scss-module__6YmyPW__descriptionScrollable",
  "event": "HistoryEventView-module-scss-module__6YmyPW__event",
  "gridWithImage": "HistoryEventView-module-scss-module__6YmyPW__gridWithImage",
  "gridWithoutImage": "HistoryEventView-module-scss-module__6YmyPW__gridWithoutImage",
  "historyContentRevealDesktop": "HistoryEventView-module-scss-module__6YmyPW__historyContentRevealDesktop",
  "historyContentRevealMobile": "HistoryEventView-module-scss-module__6YmyPW__historyContentRevealMobile",
  "historyImageFadeDesktop": "HistoryEventView-module-scss-module__6YmyPW__historyImageFadeDesktop",
  "historyImageRevealMobile": "HistoryEventView-module-scss-module__6YmyPW__historyImageRevealMobile",
  "historyImageScaleDesktop": "HistoryEventView-module-scss-module__6YmyPW__historyImageScaleDesktop",
  "historyImageTranslateDesktop": "HistoryEventView-module-scss-module__6YmyPW__historyImageTranslateDesktop",
  "image": "HistoryEventView-module-scss-module__6YmyPW__image",
  "imageButton": "HistoryEventView-module-scss-module__6YmyPW__imageButton",
  "imageFrame": "HistoryEventView-module-scss-module__6YmyPW__imageFrame",
  "imageMotion": "HistoryEventView-module-scss-module__6YmyPW__imageMotion",
  "imageScaleMotion": "HistoryEventView-module-scss-module__6YmyPW__imageScaleMotion",
  "linksMotion": "HistoryEventView-module-scss-module__6YmyPW__linksMotion",
  "revealReady": "HistoryEventView-module-scss-module__6YmyPW__revealReady",
  "revealVisible": "HistoryEventView-module-scss-module__6YmyPW__revealVisible",
  "scrollContent": "HistoryEventView-module-scss-module__6YmyPW__scrollContent",
  "staticView": "HistoryEventView-module-scss-module__6YmyPW__staticView",
  "titleMotion": "HistoryEventView-module-scss-module__6YmyPW__titleMotion",
  "yearMotion": "HistoryEventView-module-scss-module__6YmyPW__yearMotion",
  "yearSeparator": "HistoryEventView-module-scss-module__6YmyPW__yearSeparator",
  "years": "HistoryEventView-module-scss-module__6YmyPW__years",
});
